module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "cr"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First published in 2002 by Mercat Press Ltd"), _c('br'), _vm._v("\n  Reprinted 2002, 2003 (three times), 2004, 2005, 2006"), _c('br'), _vm._v("\n  New edition published 2008 by Birlinn Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Birlinn Limited"), _c('br'), _vm._v("\n  West Newington House"), _c('br'), _vm._v("\n  10 Newington Road"), _c('br'), _vm._v("\n  Edinburgh"), _c('br'), _vm._v("\n  EH9 1QS"), _c('br'), _vm._v(" "), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.birlinn.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Copyright © Jess Smith 2002, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The story ‘A Natural Love’ was first published in "), _c('i', [_vm._v("The Scots Magazine")]), _vm._v(", September 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("The moral right of Jess Smith to be identified as the author of this work has been asserted by her in accordance with the Copyright, Designs and Patents Act 1988")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("ISBN-13: 978 1 84158 702 8"), _c('br'), _vm._v("\n  eBook ISBN: 978 0 85790 178 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Version 1.0")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d49c8f88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/004_cr.vue
// module id = 66
// module chunks = 0